import { Box, Typography, useTheme } from '@material-ui/core';
import React from 'react';

import {
  containerStyle,
  getStatusWrapperStyle,
  getVersionWrapperStyle,
} from './style';







export default function DeploymentInfo({
  deplotmentVersion,
  deploymentStatus,
}) {
  const theme = useTheme();
  return (
    React.createElement(Box, { style: containerStyle,}
      , React.createElement(Typography, {
        variant: "caption",
        style: getStatusWrapperStyle(theme, deploymentStatus),}
      
        , deploymentStatus
      )
      , React.createElement(Box, { style: getVersionWrapperStyle(theme),}
        , React.createElement(Typography, { variant: "caption",}, deplotmentVersion)
      )
    )
  );
}
